// ЗАЯВКА НА ПОКУПКУ ЗА ЗВЁЗДЫ — СЛЕД ОПЕРАЦИИ, КОТОРЫЙ ПЕРЕЖИВАЕТ УХОД С ЭКРАНА.
//
// 🔴 ЗАЧЕМ (просьба оунера 2026-09-15: «добавим информационную строку обработки транзакции в разделе
// PVP, как сейчас при обмене ENRG; не прошла — сообщение об ошибке в этом же блоке, успешно —
// поздравление»). Покупка с сайта уходит в ДРУГОЕ приложение: игрок жмёт ссылку, платит в Telegram
// и возвращается когда угодно — хоть в лобби, хоть завтра. Без этой заявки единственный след
// операции жил в окне магазина, и закрывший его человек оставался гадать, ушли ли звёзды.
// Тот же класс уже разбирался в обмене $ENRG («подпись в кошельке — не зачисление»), только там
// ожидание помнит СЕРВЕР, а здесь помнить нечему: пока Telegram не подтвердил оплату, у нас нет ни
// заказа, ни строки в истории — есть только выставленный счёт, о котором знает один браузер.
//
// 🔴 ПОЭТОМУ ЗАЯВКА ЛОКАЛЬНАЯ (localStorage), И ЭТО ОСОЗНАННО: она НЕ доказательство оплаты и не
// участвует в выдаче. Судья всегда сервер — `POST /stars/claim` и запись в `GET /stars/history`;
// заявка лишь помнит, ЧТО и КОГДА игрок пошёл оплачивать, чтобы строка нашла его на любом экране.
//
// 🔴 ЗАЯВКА ПРИВЯЗАНА К ИГРОКУ: на одном устройстве играют разными аккаунтами, и чужое «покупка
// обрабатывается» в лобби — это прямое враньё про чужие деньги.
//
// 🔴 У «ОБРАБОТКИ» ЕСТЬ СРОК. Оплату можно просто не совершить (окно Telegram закрыли), и вечная
// строка «обрабатывается» стала бы несмываемой. По истечении срока заявка честно говорит, что
// оплату мы не увидели, — это НЕ «оплата не прошла», формулировки разные.

const KEY = 'cz_stars_order';

// Сколько ждём подтверждения, прежде чем сказать «оплату не увидели». 15 минут: обычная выдача
// занимает секунды, но у прода теряется ~10% запросов к Telegram, а игрок мог ещё и отвлечься.
export const ORDER_TTL_MS = 15 * 60 * 1000;

// Сколько живёт ЗАВЕРШЁННАЯ заявка, если игрок не закрыл её крестиком. Сутки: поздравление должно
// дождаться человека, который ушёл спать сразу после покупки, но не висеть в лобби вечно.
export const ORDER_KEEP_MS = 24 * 60 * 60 * 1000;

export const ORDER_PENDING = 'pending';   // счёт открыт в Telegram, ждём подтверждения сервера
export const ORDER_DONE = 'done';         // сервер выдал товар
export const ORDER_FAILED = 'failed';     // сервер ЗНАЕТ про оплату и не выдал (status !== paid)
export const ORDER_TIMEOUT = 'timeout';   // подтверждения не дождались — про оплату ничего не знаем

function load() {
  try {
    const raw = window.localStorage.getItem(KEY);
    if (!raw) return null;
    const row = JSON.parse(raw);
    return row && typeof row === 'object' ? row : null;
  } catch (e) {
    // Приватное окно, запрещённые данные сайта — заявки просто нет. Экран обязан работать и так.
    return null;
  }
}

function save(row) {
  try {
    if (row) window.localStorage.setItem(KEY, JSON.stringify(row));
    else window.localStorage.removeItem(KEY);
  } catch (e) { /* хранилище недоступно — заявка не переживёт экран, но экран не сломается */ }
}

/**
 * Заявка ТЕКУЩЕГО игрока или null.
 *
 * `userId` — `store.state.auth.id`. Пока он не приехал (`undefined`), заявку не отдаём: строка
 * мелькнула бы у того, кто ещё не опознан.
 */
export function readOrder(userId) {
  const row = load();
  if (!row || !row.id) return null;
  if (!userId || String(row.user || '') !== String(userId)) return null;
  // Закрытая заявка, которую не погасили крестиком, уходит сама через сутки.
  if (row.state !== ORDER_PENDING && Date.now() - (Number(row.at) || 0) > ORDER_KEEP_MS) {
    save(null);
    return null;
  }
  return row;
}

/**
 * Игрок открыл счёт в Telegram: с этой секунды у операции есть след.
 *
 * `top` — id последней покупки в истории ДО этого счёта. 🔴 `null` значит «снимок снять не удалось»
 * и это НЕ то же самое, что «покупок не было»: подставив 0, строка приняла бы ПЕРВУЮ же старую
 * запись за свою и поздравила бы с покупкой, которой сейчас не было (та же грабля, что в
 * `purchaseTop` на экране магазина).
 */
export function startOrder(userId, product, stars, top) {
  const row = {
    user: String(userId || ''),
    id: String((product && product.id) || ''),
    title: String((product && product.title) || ''),
    stars: Number(stars) || Number(product && product.stars) || 0,
    top: top === null || top === undefined ? null : Number(top) || 0,
    at: Date.now(),
    state: ORDER_PENDING,
  };
  save(row);
  return row;
}

/**
 * Эта ли запись истории закрывает заявку. 🔴 ДВА ПРИЗНАКА СРАЗУ — тот самый товар И запись новее
 * снимка: по одному «id больше» подошла бы любая чужая покупка, а по одному «тот же товар» —
 * покупка того же набора на прошлой неделе.
 */
export function orderMatches(row, purchase) {
  if (!row || !purchase) return false;
  const mine = String(purchase.product_id || '') === String(row.id);
  if (!mine) return false;
  if (row.top === null || row.top === undefined) return true;
  return (Number(purchase.id) || 0) > (Number(row.top) || 0);
}

/** Исход операции. Возвращает обновлённую заявку (или null, если её уже нет). */
export function setOrderState(userId, state) {
  const row = readOrder(userId);
  if (!row) return null;
  row.state = state;
  save(row);
  return row;
}

export function clearOrder() { save(null); }

/**
 * Протух ли срок ожидания. 🔴 Считаем ЗДЕСЬ, а не в компоненте: строку рисуют два экрана, и своя
 * копия срока в каждом разошлась бы молча.
 */
export function orderExpired(row, now) {
  if (!row || row.state !== ORDER_PENDING) return false;
  return (Number(now) || Date.now()) - (Number(row.at) || 0) > ORDER_TTL_MS;
}
